// extracted by mini-css-extract-plugin
export var blue = "_3i-f";
export var brand = "_3i-b";
export var darkGrey = "_3i-e";
export var disabled = "_3i-4";
export var disabledSubtle = "_3i-5";
export var error = "_3i-6";
export var green = "_3i-g";
export var grey = "_3i-d";
export var icon = "_3i-0";
export var inherit = "_3i-a";
export var lightGrey = "_3i-c";
export var orange = "_3i-i";
export var pink = "_3i-k";
export var primary = "_3i-1";
export var purple = "_3i-l";
export var red = "_3i-j";
export var secondary = "_3i-2";
export var success = "_3i-9";
export var tertiary = "_3i-3";
export var warning = "_3i-7";
export var warningSecondary = "_3i-8";
export var white = "_3i-m";
export var yellow = "_3i-h";